module.exports = __webpack_public_path__ + "media/images/kinopoisk-icon-white-21198327cb91f1abce7c47538b002b4a.png";